<template>
  <f7-page>
   
  <p style="background: #fff;"><img src="../static/images/sili/S1.png"  width="100%" alt="" srcset=""></p>
   
  </f7-page>
</template>
<script>
  export default {};
</script>